import { palette } from 'assets/styles/colors';

const backgroundColor = palette.neutral[50];
const focusedBackgroundColor = palette.neutral[100];

const textField = {
  MuiFilledInput: {
    styleOverrides: {
      root: {
        background: backgroundColor,
        '&.Mui-focused': {
          backgroundColor: focusedBackgroundColor,
        },
      },
    },
  },
};

export default textField;
